import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeBankAccountNumberCommand extends BaseCommand {
  CommandName = "ChangeBankAccountNumber";
  Command: { Value: number | null };
  constructor(sessionId: string, operationId: string, value: number | null) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
